// Manually update when bumping version
const VERSION = '0.4.0';
export { VERSION };
